module.exports = __webpack_public_path__ + "img/icomoon.f5a56e5.svg";